import { IMG_NO_RESULTS_PRODUCT_COMPARISON } from "~/utils/url/staticResources";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { Button, Box, Stack, Typography, styled } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { useSession } from "~/app/providers/SessionProvider";

const Container = styled(Stack)({
  marginTop: 32,
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
});

const EmptyComparison = ({ openQuickEntry }: { openQuickEntry: () => void }) => {
  const { t } = useTranslation();
  const maxSize = useSession()?.productComparison.maxSize ?? 0;

  return (
    <>
      <PageTitle title={t("comparisonPage.title", { length: 0, maxSize })} />

      <Container>
        <Typography variant="displaySmall" sx={{ mb: 2.5 }}>
          {t("emptyComparison.title")}
        </Typography>

        <Box component="img" src={IMG_NO_RESULTS_PRODUCT_COMPARISON} alt="" sx={{ mb: 4 }} />

        <Box sx={{ mb: 1.25 }}>
          <Button onClick={openQuickEntry}>{t("emptyComparison.addProducts")}</Button>
        </Box>

        <Button variant={"text"} onClick={() => redirectToUrl(HOMEPAGE)}>
          {t("emptyComparison.backHome")}
        </Button>
      </Container>
    </>
  );
};

export default EmptyComparison;
